import React from 'react';
import { Retry } from '@components/common';
import { useSelector } from 'react-redux';
import { currentMetricsMetaSelector } from '@store/common/selectors';
import { StyledBaseTable, TableWrapper } from './styled';
import useFetchData from './useFetchData';
import { buildColumns } from './utils';
import SortIndicator from './SortIndicator';
import useSetImpactedViewersExport from './useSetImpactedViewersExport';
import TableSkeleton from '@src/components/common/Skeleton/TableSkeleton';

function Table() {
  const currentMetricsMeta = useSelector(currentMetricsMetaSelector);
  const columns: any = buildColumns(currentMetricsMeta);

  const { status, rows, refetch, sortBy, onColumnSort } = useFetchData({});

  useSetImpactedViewersExport({ columns, rows });

  return (
    <TableWrapper>
      <Retry
        isLoading={status === 'loading'}
        showError={status === 'error'}
        mountChildAlways={false}
        fetchData={refetch}
        LoadingLayer={TableSkeleton}
      >
        {rows && rows.length === 0 ? (
          <div style={{ height: 100, margin: '10px', fontSize: '16px' }}>
            No impacted viewers found.
          </div>
        ) : (
          <StyledBaseTable
            style={{ height: '100%', minHeight: 600 }}
            data={rows}
            columns={columns}
            headerHeight={50}
            rowHeight={45}
            fixed
            rowKey="VIEWER_ID"
            sortBy={sortBy}
            onColumnSort={onColumnSort}
            components={{
              SortIndicator,
            }}
          />
        )}
      </Retry>
    </TableWrapper>
  );
}

export default Table;
